import Grid from '@material-ui/core/Grid';
import { mainContentColor } from '../../lib/Color';
import { Card } from '@material-ui/core';
import { Typography } from "@material-ui/core";
import { modalStressTextColor, modalSelectedColor } from "../../lib/Color";
import { PositionType, MemberType } from "../../Type/TeamType"
import { ModeType } from '../hooks/AssetSettingModalType';
import SettingConfirmExtensionArea from './SettingConfirmExtensionArea';
import MemberStatusText from './MemberStatusText';

type Props = {
    selectedMode: ModeType,
    position: PositionType;
    member: MemberType;
    selectedPosition: PositionType;
    onSelectStateModeAndPosition: (mode: ModeType, position: PositionType) => void,
}

const SettingConfirmRow: React.FC<Props> = ({ selectedMode, position, member, selectedPosition, onSelectStateModeAndPosition }) => {

    const isSelected = position === selectedPosition
    const isModeSelected = (selectMode: ModeType) => {
        return isSelected && selectMode === selectedMode
    }
    const makeAssetBackgroundColor = (selectMode: ModeType) => {
        return isModeSelected(selectMode) ? modalSelectedColor : "initial"
    }

    return (
        <Grid item style={{ width: "95%", marginTop: "20px", marginBottom: "10px" }}>
            <Typography variant="h5" style={{ color: modalStressTextColor, margin: "10" }}>{position}: {member.hero?.name}</Typography>
            <Card style={isSelected ? {
                background: mainContentColor,
                border: "4px solid",
                borderRadius: "8px",
                borderColor: "white"
            } : { background: mainContentColor, }}
            >
                <div style={{
                    float: "left",
                    paddingTop: "8px",
                    paddingBottom: "8px",
                    backgroundColor: makeAssetBackgroundColor("Hero")
                }}
                    onClick={() => onSelectStateModeAndPosition("Hero", position)}
                >
                    {member.hero ? <img
                        src={"https://www.mycryptoheroes.net/images/heroes/2000/" + member.hero.id + ".png"}
                        style={{ width: 128, height: 128 }}
                    /> : <div
                        style={{
                            width: 128, height: 128,
                        }}
                    >
                        <Typography variant="h5" style={{ color: modalStressTextColor, margin: "10", top: "50%", position: "relative", textAlign: "center" }}>未設定</Typography>
                    </div>}
                </div>
                <div style={{ display: "flex", flexDirection: "column", float: "left" }}>
                    <SettingConfirmExtensionArea extensionId={member.leftExtension?.id} isModeSelected={isModeSelected("ExtensionLeft")} onClick={() => onSelectStateModeAndPosition("ExtensionLeft", position)} />
                    <SettingConfirmExtensionArea extensionId={member.rightExtension?.id} isModeSelected={isModeSelected("ExtensionRight")} onClick={() => onSelectStateModeAndPosition("ExtensionRight", position)} />
                </div>
                <div style={{ display: "flex", flexDirection: "column", margin: "10" }} onClick={() => onSelectStateModeAndPosition("Hero", position)} >
                    <MemberStatusText status={"HP"} hero={member.hero?.hp} leftExtension={member.leftExtension?.hp} rightExtension={member.rightExtension?.hp} />
                    <MemberStatusText status={"PHY"} hero={member.hero?.phy} leftExtension={member.leftExtension?.phy} rightExtension={member.rightExtension?.phy} />
                    <MemberStatusText status={"INT"} hero={member.hero?.int} leftExtension={member.leftExtension?.int} rightExtension={member.rightExtension?.int} />
                    <MemberStatusText status={"AGI"} hero={member.hero?.agi} leftExtension={member.leftExtension?.agi} rightExtension={member.rightExtension?.agi} />
                    {/* <Typography style={{ color: modalStressTextColor, margin: "10" }}> Passive: {member.hero?.passive}</Typography> */}
                    <Typography style={{ color: modalStressTextColor, margin: "10" }}> Passive: {member.hero?.passive}</Typography>
                    <Typography style={{ color: modalStressTextColor, margin: "10", backgroundColor: makeAssetBackgroundColor("ArtSkill") }}> Art :{member.artSkill?.name}</Typography>
                </div>
            </Card>
        </Grid >
    );
}

export default SettingConfirmRow;